import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CinemaViewModel } from 'libs/core/src/lib/model/view-model/cinema/cinema.view.model';
import { AppService } from 'libs/core/src/lib/service/app.service';
import { BackgroundService } from 'libs/core/src/lib/service/background.service';
import { Subject } from 'rxjs';
import { ENVIRONMENT_TOKEN } from '@lib/core';
import { FormEventModel } from './form-event.model';

@Component({
  template: ''
})
export abstract class RefundFormComponent implements OnInit {
  @Input() formErrors: string[];
  @Input() formEvent: Subject<FormEventModel>;

  public refundForm: FormGroup;
  public formSubmitAttempt: boolean;
  public allowTimeBeforeScreening: number;

  constructor(@Inject(ENVIRONMENT_TOKEN) protected environment: any, protected appService: AppService, protected backgroundService: BackgroundService) {
    this.allowTimeBeforeScreening = this.environment.constants?.refundAllowTimeBeforeScreening ?? 30;
  }

  ngOnInit() {
    this.backgroundService.changeDeleteOrderOnWindowUnloadState(false);
    this.refundForm = this.getFrom();
    this.formEvent.subscribe((event) => {
      if (event.action === 'submit') {
        this.formSubmitAttempt = true;
        if (this.refundForm.valid) {
          this.formEvent.next({ action: 'validated', form: this.refundForm });
        }
      }
    });
  }

  abstract getFrom(): FormGroup;

  cinemaSelectCompare(a: CinemaViewModel, b: CinemaViewModel) {
    return a && b && a.id === b.id;
  }
}
